/* 3 Nov 2026 (owner, canvas "Cart delivery sheet · calmer"): words and small layout helpers for the cart's delivery sheet.
   Never changes what can be picked: dates, slots, fees and rules stay in gh-delivery-scheduler.js (Grok's).
   Looks: assets/gh-ds-calm.css. Everything here is text, a few links, and classes the CSS reads. */
(() => {
  if (window.__ghDsCalm) return;
  window.__ghDsCalm = true;
  const MS = /^ms/i.test(document.documentElement.lang || '');
  const WA = '60182891225';
  const T = MS ? {
    title: 'Bila patut ia tiba?',
    sender: 'Butiran pengirim',
    pc: 'Poskod penerima',
    lead: (d) => `Dibuat segar untuk anda, jadi hari paling awal ialah <b>${d}</b>.`,
    leadRe: /penghantaran paling awal pada (.+?)\.?$/,
    areas: 'Kawasan kami',
    recip: '+ Tambah nama dan telefon penerima',
    wa: 'Perlukan masa yang tepat? WhatsApp kami',
    waOn: (d, a) => `Hai GiftHub, saya membuat pesanan untuk penghantaran pada ${d}${a ? ` (${a})` : ''}. Bolehkah ia tiba pada masa yang tepat?`,
    waAny: (a) => `Hai GiftHub, saya mahu hadiah saya tiba pada masa yang tepat${a ? ` (${a})` : ''}. Boleh bantu?`
  } : {
    title: 'When should it arrive?',
    sender: 'Sender details',
    pc: "Recipient's postcode",
    lead: (d) => `Made fresh for you, so the earliest day is <b>${d}</b>.`,
    leadRe: /earliest delivery is (.+?)\.?$/,
    areas: 'Areas we cover',
    recip: "+ Add the recipient's name and phone",
    wa: 'Need an exact time? WhatsApp us',
    waOn: (d, a) => `Hi GiftHub, I'm ordering for delivery on ${d}${a ? ` (${a})` : ''}. Can it arrive at an exact time?`,
    waAny: (a) => `Hi GiftHub, I'd like my gift to arrive at an exact time${a ? ` (${a})` : ''}. Can you help?`
  };
  const PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false"><path d="M12 21s-6.5-5.6-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';
  const WAI = '<svg viewBox="0 0 24 24" fill="#25D366" aria-hidden="true" focusable="false"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>';
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
  // the label of a heading without its number badge
  function relabel(h, t) {
    if (!h) return;
    const n = [...h.childNodes].find((c) => c.nodeType === 3 && c.textContent.trim());
    if (n && n.textContent !== t) n.textContent = t;
  }
  const areaName = (ds) => { const b = ds.querySelector('.gh-ds__areabtn.is-on .gh-ds__slot-txt > b'); return b ? b.textContent.trim() : ''; };
  function pickedDay(ds) {
    const on = ds.querySelector('.gh-ds__day.is-on, .gh-ds__chip.is-on');
    const k = on && on.dataset.dsDate;
    if (!k) return '';
    return new Date(k + 'T00:00:00Z').toLocaleDateString(MS ? 'ms-MY' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  }

  function setup(ds) {
    if (ds.__ghCalm) return;
    ds.__ghCalm = true;
    ds.classList.add('gh-dsc');
    setText(ds.querySelector('.gh-ds__title'), T.title);
    relabel(ds.querySelector('#gh-ds-l5'), T.sender);
    setText(ds.querySelector('.gh-ds__pc .gh-ds__exactlabel'), T.pc);

    const area = ds.querySelector('.gh-ds__area');
    if (area) {
      const where = document.createElement('div');
      where.className = 'gh-dsc-where';
      where.innerHTML = `${PIN}<span><b></b><button type="button" class="gh-dsc-areasbtn" aria-expanded="false">${esc(T.areas)}</button></span>`;
      const anchor = area.querySelector('.gh-ds__areas');
      if (anchor) area.insertBefore(where, anchor); else area.prepend(where);
      where.querySelector('button').addEventListener('click', (e) => {
        const open = area.classList.toggle('gh-dsc-open');
        e.currentTarget.setAttribute('aria-expanded', String(open));
      });
    }

    const sup = ds.querySelector('.gh-ds__support');
    if (sup) {
      sup.innerHTML = `<a class="gh-dsc-wa" href="https://wa.me/${WA}" target="_blank" rel="noopener">${WAI}<span>${esc(T.wa)}</span></a>`;
      const a = sup.querySelector('a');
      const fill = () => { const d = pickedDay(ds), n = areaName(ds); a.href = `https://wa.me/${WA}?text=${encodeURIComponent(d ? T.waOn(d, n) : T.waAny(n))}`; };
      ['pointerdown', 'focus', 'click'].forEach((ev) => a.addEventListener(ev, fill));
    }

    const recip = ds.querySelector('.gh-ds__recip');
    if (recip) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'gh-dsc-recipbtn';
      b.textContent = T.recip;
      recip.parentElement.insertBefore(b, recip);
      b.addEventListener('click', () => { ds.classList.add('gh-dsc-recip'); const i = recip.querySelector('input'); if (i) i.focus(); });
    }

    let q = false;
    new MutationObserver(() => { if (q) return; q = true; requestAnimationFrame(() => { q = false; sync(ds); }); })
      .observe(ds, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    sync(ds);
  }

  function sync(ds) {
    // lead time: "Made fresh for you, so the earliest day is Fri 6 Nov."
    const ln = ds.querySelector('.gh-ds__leadnote');
    if (ln && !ln.hidden) {
      const src = ln.querySelector('b') ? ln.dataset.ghSrc || '' : ln.textContent;
      const m = src.match(T.leadRe);
      if (m) { ln.dataset.ghSrc = src; const h = T.lead(esc(m[1])); if (ln.innerHTML !== h) ln.innerHTML = h; }
    }
    // the one area this cart delivers to
    setText(ds.querySelector('.gh-dsc-where b'), areaName(ds));
    // the recipient fields open by themselves once they hold something
    const r = ds.querySelector('.gh-ds__recip');
    if (r && !ds.classList.contains('gh-dsc-recip') && [...r.querySelectorAll('input')].some((i) => i.value.trim())) ds.classList.add('gh-dsc-recip');
    mergeLegend(ds.querySelector('.gh-ds__legend'));
  }

  // One line per note: "8 Nov Deepavali" + "9 Nov Deepavali" -> "8–9 Nov Deepavali";
  // every "Sunday – no delivery" (closed-Sunday areas) -> "Sundays · No delivery"
  const SUN = MS ? /^Ahad\s+[–-]\s+/i : /^Sunday\s+[–-]\s+/i;
  function days(list) {
    // ["8 Nov","9 Nov","15 Nov"] -> "8–9, 15 Nov"
    const ds = list.map((t) => { const [d, m] = t.trim().split(/\s+/); return { d: +d, m }; });
    if (ds.some((x) => !x.d || x.m !== ds[0].m)) return list.join(', ');
    const out = [];
    for (let i = 0; i < ds.length; i++) {
      let j = i;
      while (j + 1 < ds.length && ds[j + 1].d === ds[j].d + 1) j++;
      out.push(j > i ? `${ds[i].d}–${ds[j].d}` : `${ds[i].d}`);
      i = j;
    }
    return `${out.join(', ')} ${ds[0].m}`;
  }
  function mergeLegend(ul) {
    if (!ul || ul.__ghDone === ul.innerHTML) return;
    const groups = new Map();
    [...ul.children].forEach((li) => {
      const b = li.querySelector('b'), s = li.querySelector('span');
      if (!b || !s) return;
      const k = li.className + '|' + s.textContent;
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(li);
    });
    groups.forEach((lis) => {
      if (lis.length < 2) return;
      const first = lis[0], b = first.querySelector('b'), s = first.querySelector('span');
      if (SUN.test(s.textContent)) {
        b.textContent = MS ? 'Setiap Ahad' : 'Sundays';
        const rest = s.textContent.replace(SUN, '');
        s.textContent = rest.charAt(0).toUpperCase() + rest.slice(1);
      } else {
        b.textContent = days(lis.map((li) => li.querySelector('b').textContent));
      }
      lis.slice(1).forEach((li) => li.remove());
    });
    ul.__ghDone = ul.innerHTML;
  }

  const find = () => { const ds = document.querySelector('.gh-ds'); if (ds) { setup(ds); return true; } return false; };
  if (!find()) {
    const mo = new MutationObserver(() => { if (find()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
